var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShotListIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.163,
    height: 37.163,
    viewBox: "0 0 37.163 37.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 37.163,
    height: 37.163,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M37.163,18.581A18.581,18.581,0,1,1,18.582,0,18.581,18.581,0,0,1,37.163,18.581",
    fill: "#00d544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M21.461,23.371c1.916,0,3.833,0,5.749,0A1.887,1.887,0,0,1,28.989,24.6a1.92,1.92,0,0,1-1.82,2.6q-5.714,0-11.426,0a1.914,1.914,0,0,1-.44-3.786,2.441,2.441,0,0,1,.506-.042q2.826,0,5.652,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M21.437,13.792c-1.9,0-3.8,0-5.7,0a1.915,1.915,0,1,1,.032-3.829c1.746-.006,3.493,0,5.24,0q3.056,0,6.113,0a1.923,1.923,0,0,1,1.942,1.478,1.9,1.9,0,0,1-1.852,2.35c-1.124.013-2.248,0-3.372,0h-2.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M21.468,16.666c1.892,0,3.784,0,5.676,0a1.912,1.912,0,0,1,.285,3.81c-.121.012-.243.017-.364.017q-5.628,0-11.255,0a1.912,1.912,0,0,1-.285-3.813c.37-.03.744-.015,1.116-.016h4.827",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M9.953,13.79A1.914,1.914,0,1,1,11.88,11.9,1.906,1.906,0,0,1,9.953,13.79",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M9.967,23.372a1.914,1.914,0,1,1-1.918,1.9,1.913,1.913,0,0,1,1.918-1.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M9.958,20.494a1.913,1.913,0,1,1,1.922-1.9,1.91,1.91,0,0,1-1.922,1.9",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotListIconNew);
export default __webpack_public_path__ + "static/media/shotListIcon_new.dbc6f3b50088f9bb8473319a11bc24e9.svg";
export { ForwardRef as ReactComponent };